import { createContext, useContext, useState, useRef, useEffect } from 'react';

const PageContext = createContext(null);

export const PageProvider = ({ children }) => {
  let initPage = "Software Engineer";
  if (window.location.search.startsWith("?actor")) {
    initPage = "Actor";
  }
  const [page, setPage] = useState(initPage);
  const getResumeLocation = () => {
    if (page === "Software Engineer") {
      return "/resume.pdf";
    } else if (page === "Actor") {
      return "/actingResume.pdf";
    } else {
      return "/resume.pdf";
    }
  }
  const canPageChange = useRef(false);

  // Run only after the page is done loading.
  useEffect(() => {
    canPageChange.current = true;
  }, []);

  return (
    <PageContext.Provider value={{ page, setPage, getResumeLocation, canPageChange }}>
      {children}
    </PageContext.Provider>
  );
};

export const usePage = () => useContext(PageContext);
